import React from 'react'
import '../Styles/categoria.css'


const Categoria = (props) => {

  return (
    <div className="categoria">          
            <div 
              className="categoria_portada" 
              style={{
                backgroundImage: `url(${props.cat_img})`
                }}>
              {props.cat_nomb}
            </div>
    </div>
  )
}

export default Categoria